import { api } from "@lib/orpc-client"
import useSWR from "swr"

const useReferralReward = () => {
    const { data, isLoading, error } = useSWR(
        'walletV2.referral.rewards',
        () => api.walletV2.referral.rewards({})
    )

    return {
        data,
        isLoading,
        error
    }
}

export default useReferralReward
